import { c as _c } from "react/compiler-runtime";
import Typography from '@precis-digital/kurama/Typography';
import { ChartCard } from 'shared/components/ChartCard';
import { useCurrentClient } from 'shared/context/ClientContext';
import { type CopilotChart, isCopilotDataChart } from 'shared/copilot/charts/dataChartTypes';
import { mapCopilotChartToChartCardProps } from 'shared/copilot/charts/mapCopilotChartToChartCardProps';
import { mapDataChartToChartCardProps } from 'shared/copilot/charts/mapDataChartToChartCardProps';
import { useMemo, type ReactElement } from 'react';
import { useTranslation } from 'shared/translations';
interface CopilotChartCardProps {
  chart: CopilotChart;
}
export const CopilotChartUnavailable = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "copilot.toolCall"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("chartUnavailable");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const chartUnavailableLabel = t1;
  let t2;
  if ($[3] !== chartUnavailableLabel) {
    t2 = <Typography variant="body3">{chartUnavailableLabel}</Typography>;
    $[3] = chartUnavailableLabel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};

/**
 * Renders agent charts via ChartCard. Unmappable payloads show an explicit fallback
 * (no parallel Recharts implementation).
 */
const CopilotChartCard = t0 => {
  const $ = _c(6);
  const {
    chart
  } = t0;
  const {
    currentClient
  } = useCurrentClient();
  let t1;
  if ($[0] !== chart || $[1] !== currentClient.currency) {
    t1 = isCopilotDataChart(chart) ? mapDataChartToChartCardProps(chart, {
      currencyCode: currentClient.currency
    }) : mapCopilotChartToChartCardProps(chart);
    $[0] = chart;
    $[1] = currentClient.currency;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const chartCardProps = t1;
  if (chartCardProps == null) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <CopilotChartUnavailable />;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== chartCardProps) {
    t2 = <ChartCard {...chartCardProps} />;
    $[4] = chartCardProps;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default CopilotChartCard;